import { useDispatch, useSelector } from 'react-redux'
import { selectIsProductTypeComplete } from '../../../../../helper/proposal/proposal-is-complete-form-helper'
import Label from '../../../../ui/label'
import LoadingCategory from '../../../../ui/loading-category'
import ErrorFetch from '../../../../ui/error-fetch-category'
import { useQueries } from '../../../../../hooks/services/queries/use-queries'
import { useMemo } from 'react'
import { setSelectedBasicPlansBox } from '../../../../../features/gms-proposal-forms/types-proposal-product-basic-plan/types-proposal-product-basic-plan-slice'
import { SubTypeOption, TypeOfProductResponse } from '../../../../../api/gms/group-category/group-category-api-state'
import Checkbox from '../../../../ui/checkbox'
import { useProposalTypeData } from '../../../../../hooks/proposal/use-proposal-type-data'

export default function ClientInputBasicPlans() {

    const { typeOfProduct, isLoadingTypeOfProduct, isErrorTypeOfProduct } = useQueries();
    const {
        basicPlan,
        product: selectedProduct,
    } = useProposalTypeData()
    const isErrorLoading = isErrorTypeOfProduct || isLoadingTypeOfProduct
    const dispatch = useDispatch()
    const isProductTypeComplete = useSelector(selectIsProductTypeComplete);

    const product = typeOfProduct?.find(
        (p: TypeOfProductResponse) =>
            p.product_id === selectedProduct?.id
    );

    const basicPlansData = product?.basic_plans;

    const mappedOptions: SubTypeOption[] = useMemo(
        () =>
            basicPlansData?.map(item => ({
                id: item.basic_plan_id,
                name: item.basic_plan_name
            })) || [],
        [basicPlansData]
    );

    const handleChangeBasicPlan = (e: React.ChangeEvent<HTMLInputElement>, option: SubTypeOption) => {
        dispatch(setSelectedBasicPlansBox(option));
    };

    return (
        <div className='space-y-2'>
            <Label
                label='Basic Plans'
                fontWeight="font-semibold text-gray-800"
                fontSize="text-xs"
                requiredText=' *'
                isRequired={true}
            />
            <div className={`grid gap-2 ${ isErrorLoading ? 'grid-cols-1' : 'grid-cols-1' }`} >
                {isLoadingTypeOfProduct ? (
                    <LoadingCategory />
                ) : isErrorTypeOfProduct ? (
                    <ErrorFetch />
                ) : (
                    mappedOptions.map(option => {
                        const disabledGYRT = option?.name === 'Group Comprehensive Benefits Plan (Retirement)'
                        const isSelected = basicPlan?.id === option.id
                        const isDisabled = !isProductTypeComplete || disabledGYRT
                        return (
                            <Checkbox 
                                key={option.id}
                                disabled={isDisabled} 
                                isSelected={isSelected} 
                                option={option} 
                                onChange={handleChangeBasicPlan}
                            />
                        )
                    })
                )}
            </div>
        </div>
    )
}